module.exports = __webpack_public_path__ + "img/Alphabounce+_Run_EM_Shoes.03027def.png";